import { Button, Card, Col, DatePicker, Form, Row, Skeleton, Space, Table } from 'antd'
import moment from 'moment';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf, lpowerdbypdf, ldatepdf, pdfGenerate } from '../../../utils/pdf';
import { DownloadOutlined, FileExcelOutlined, FilePdfOutlined, SearchOutlined } from '@ant-design/icons';

import TableResponsive from "../../../../contents/AntTableResponsive";
import ReactExport from "react-export-excel";
import Text from 'antd/lib/typography/Text';
import { SelectClass } from '../../../select/SelectClass';
import { SelectFeeHeadNull } from '../../../select/SelectFeeHeadNull';
require('jspdf-autotable');



let fd = '';
let td = '';
let totalsum = '';
export default function FeeHeadCollectionClass(props) {
    const feeHeadCollectionReportClass = useStoreState((state) => state.saccount.feeHeadCollectionReportClass);
    const fetchfeeHeadCollectionReportclass = useStoreActions((state) => state.saccount.fetchfeeHeadCollectionReportclass);
    const fetchdateToDateClassSingleFeeHeadCollection = useStoreActions((state) => state.saccount.fetchdateToDateClassSingleFeeHeadCollection);

    const loading = useStoreState((state) =>  state.saccount.loading);

    const [reportForm] = Form.useForm();
    const [feeHeadId, setfeeHeadId] = useState<any>(null)
    const reportFormSubmit = (value) => {
        let postData:any = {
            fromDate: moment(value?.fromDate).format("YYYY-MM-DD"),
            toDate: moment(value?.toDate).format("YYYY-MM-DD"),
            classId: value?.classId,
        }
        fd = moment(value?.fromDate).format("YYYY-MM-DD");
        td = moment(value?.toDate).format("YYYY-MM-DD");
        if (value.feeHeadId===null){
            setfeeHeadId(null)
            fetchfeeHeadCollectionReportclass(postData);
        } else if (value.feeHeadId!==null){
            postData.feeHeadId = value.feeHeadId;
            setfeeHeadId(value.feeHeadId)
            fetchdateToDateClassSingleFeeHeadCollection(postData);
        }
       
    };

    const columns = [

        {
            title: 'Fee Head',
            dataIndex: 'feeHeadName',
            key: 'feeHeadName',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Fee Collection',
            dataIndex: 'feeCollection',
            key: 'feeCollection',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Fine Collection',
            dataIndex: 'fineCollection',
            key: 'fineCollection',
            showOnResponse: true,
            showOnDesktop: true,
        },
        {
            title: 'Total Collection',
            dataIndex: 'totalCollection',
            key: 'totalCollection',
            showOnResponse: true,
            showOnDesktop: true,
        },
    ];

    function exportPdf() {
        var details ;
        
        if (feeHeadId!==null){
            details = `Fee Head Collection of ${$(".classSelect").text()}, Fee Head:${$(".feeSelect").text()} from ${fd} to ${td}`;
        } else details = `Fee Head Collection of ${$(".classSelect").text()} from ${fd} to ${td}`;

        var doc = new jsPDF("l", "mm", "a4");


        pdfDataL(doc, details);

        var col = ["Fee Head", "Fee Collection", "Fine Collection", "Total Collection",];

        var rows: any = [];

        var temp: any = []


        feeHeadCollectionReportClass.forEach(element => {
            var temp = [element.feeHeadName, element.feeCollection, element.fineCollection,
            element.totalCollection];
            rows.push(temp);
        });

        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // FOOTER
            var str = lpowerdbypdf + data.pageCount;
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp + ldatepdf;
            }
            doc.setFontSize(8);
            var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            doc.text(str, data.settings.margin.right, pageHeight - 10);
        };

        doc.autoTable(col, rows, {
            headerStyles: {
                lineWidth: .01,
                lineColor: [224, 224, 224]
            },
            columnStyles: {
                3: { overflow: 'linebreak' },
                0: { overflow: 'linebreak' },
                1: { overflow: 'linebreak' },
                2: { overflow: 'linebreak' },
                5: { overflow: 'linebreak' },
                6: { overflow: 'linebreak' },
                7: { overflow: 'linebreak' },
                8: { overflow: 'linebreak' },
            },
            theme: "grid",
            startY: 45,
            addPageContent: pageContent
        });



        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save(details + ".pdf");

    }

    return (
        <>
            <>
                <Form
                    layout="vertical"
                    onFinish={reportFormSubmit}
                    id="basic-info"
                    form={reportForm}
                >
                    <Row gutter={8}>
                        <Col xs={24} sm={24} md={24} lg={1} xl={1}> </Col>


                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Form.Item
                                name="classId"
                                label="Select Class"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please select class" },
                                ]}
                            >

                                <SelectClass />
                            </Form.Item>
                        </Col>                       
                         <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Form.Item
                                name="feeHeadId"
                                label="Select Fee"
                                className="title-Text"
                                initialValue={null}
                            >

                              <SelectFeeHeadNull/>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Form.Item
                                name="fromDate"
                                label="From Date"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please enter from date" },
                                ]}
                            >

                                <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Form.Item
                                name="toDate"
                                label="To Date"
                                className="title-Text"
                                rules={[
                                    { required: true, message: "Please enter to date" },
                                ]}
                            >

                                <DatePicker style={{ width: '100%' }} placeholder="Select Date" format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={2} xl={2}>
                            <Space size="small" >
                                <Button type="primary" htmlType="submit" style={{ height: 40 }} icon={<SearchOutlined />}>
                                    Search
                                </Button>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={2} xl={2}> </Col>
                    </Row>
                </Form>
                {feeHeadCollectionReportClass ===null && < Skeleton loading={loading} paragraph={{rows:10}} />}
                {feeHeadCollectionReportClass?.length > 0 &&
                    <>
                        <TableResponsive
                            antTableProps={{
                                showHeader: true,
                                columns: columns,
                                dataSource: feeHeadCollectionReportClass,
                                filterData: feeHeadCollectionReportClass,
                                pagination: true,
                                bordered: true,
                                rowKey: "masterId",
                                summary: function () {
                                    let totalfeeCollection = 0;
                                    let totalfineCollection = 0;
                                    let totaltotalCollection = 0;

                                    feeHeadCollectionReportClass?.forEach(({ feeCollection, fineCollection, totalCollection }) => {
                                        totalfeeCollection += feeCollection;
                                        totalfineCollection += fineCollection;
                                        totaltotalCollection += totalCollection;
                                    });

                                    return (
                                        <>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell index={0}>
                                                    Grand Total
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell index={1}>
                                                    <Text type="danger" strong>{totalfeeCollection}</Text>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell index={2}>
                                                    <Text type="danger" strong>{totalfineCollection}</Text>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell index={3}>
                                                    <Text type="danger" strong>{totaltotalCollection}</Text>
                                                </Table.Summary.Cell>


                                            </Table.Summary.Row>

                                        </>
                                    );
                                }
                            }}
                            mobileBreakPoint={768}

                        />
                        <Space style={{ float: 'right' }} size="middle">

                            <Button type="primary" icon={<FilePdfOutlined />} onClick={exportPdf} > Download PDF </Button>
                        </Space>
                    </>
                }
            </>
        </>
    )
}
